import Axios from "axios";
import { useState, useEffect } from 'react'

export const useCurrentCity = () => {

    const [city, setCity] = useState(null)

    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(pos => {
                Axios.get("https://nominatim.openstreetmap.org/reverse?format=json&lat=" + pos.coords.latitude + "&lon=" + pos.coords.longitude).then(resp => {
                    setCity(resp.data.address.state_district)
                })
            }, () => console.log("error"))

        }
    }, [])


    return city
};